import { render, staticRenderFns } from "./documentation-nav.component.vue?vue&type=template&id=2a061fa4&scoped=true&"
import script from "./documentation-nav.component.vue?vue&type=script&lang=js&"
export * from "./documentation-nav.component.vue?vue&type=script&lang=js&"
import style0 from "./documentation-nav.component.vue?vue&type=style&index=0&id=2a061fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a061fa4",
  null
  
)

export default component.exports